<template>
  <div>
    <div v-if="showAltDemographics">
      <div v-if="$vuetify.breakpoint.smAndDown">
        <v-flex xs12>
          <v-card style="padding: 10px">
            <div>
              <v-form v-model="valid" ref="form">
                <v-container fluid>
                  <v-flex xs12>
                    <span class="commonFont" style="color: #00558c"
                      >The information you have submitted does not match our
                      records on file. Please complete the following to be
                      contacted by a Globe Life agent.</span
                    >
                  </v-flex>

                  <br />
                  <br />

                  <v-flex xs11>
                    <v-text-field
                      v-model="firstName"
                      :rules="firstNameRules"
                      label="Employee First Name"
                      v-capitalizeName="firstName"
                      ref="employeeName"
                      >></v-text-field
                    >
                  </v-flex>

                  <v-flex xs11>
                    <v-text-field
                      v-model="middleName"
                      label="Employee Middle Name"
                      v-capitalizeName="middleName"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs11>
                    <v-text-field
                      v-model="lastName"
                      :rules="lastNameRules"
                      label="Employee Last Name"
                      v-capitalizeName="lastName"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs11>
                    <v-text-field
                      v-model.trim="homePhone"
                      label="Primary Phone"
                      :rules="phoneRules"
                      ref="empPhone"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs11>
                    <v-text-field
                      v-model.trim="workPhone"
                      label="Work Phone"
                      :rules="phoneRules2"
                      ref="empWrkPhone"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs11>
                    <v-text-field
                      v-model.trim="email"
                      :rules="emailRules"
                      label="E-Mail"
                      ref="empEmail"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs11>
                    <v-btn color="#00558c" @click="submit" dark>Submit</v-btn>
                  </v-flex>
                  <v-flex xs11>
                    <v-btn color="#00558c" @click="retry" dark
                      >Retry Verification</v-btn
                    >
                  </v-flex>
                </v-container>
              </v-form>
            </div>
          </v-card>
        </v-flex>
      </div>
      <div v-else>
        <v-layout justify-center align-content-center>
          <v-card>
            <v-toolbar color="#00558c" dark>
              <v-card-title class="headline" color="white"
                >Employee Record Not Located</v-card-title
              >
            </v-toolbar>
            <div style="padding: 25px">
              <v-layout justify-center align-content-center>
                <v-subheader class="commonFont" style="color: #00558c">
                  <br />The information you have submitted does not match our
                  records on file. Please complete the following to be contacted
                  by a Globe Life agent.
                </v-subheader>
              </v-layout>
              <br />
              <br />
              <v-form v-model="valid" ref="form">
                <v-container fluid>
                  <v-layout row wrap align-center>
                    <v-flex xs4>
                      <v-text-field
                        v-model="firstName"
                        :rules="firstNameRules"
                        label="First Name"
                        v-capitalizeName="firstName"
                        ref="employeeName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="middleName"
                        label="Middle Name"
                        v-capitalizeName="middleName"
                        >></v-text-field
                      >
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="lastName"
                        :rules="lastNameRules"
                        label="Last Name"
                        v-capitalizeName="lastName"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>

                  <v-layout row align-start>
                    <v-flex xs3>
                      <v-text-field
                        v-model.trim="homePhone"
                        label="Primary Phone"
                        :rules="phoneRules"
                        ref="empPhone"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs3>
                      <v-text-field
                        v-model.trim="workPhone"
                        label="Work Phone"
                        :rules="phoneRules2"
                        ref="empWrkPhone"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                        v-model.trim="email"
                        :rules="emailRules"
                        label="E-Mail"
                        ref="empEmail"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <br />
                  <br />
                </v-container>
              </v-form>

              <v-layout justify-start align-content-start>
                <v-btn color="#00558c" @click="retry" dark
                  >Retry Verification</v-btn
                >

                <v-spacer></v-spacer>
                <v-btn color="#00558c" @click="submit" dark>Submit</v-btn>
              </v-layout>
            </div>
          </v-card>
        </v-layout>
      </div>
    </div>
    <div v-if="showSubmitted">
      <v-layout justify-center align-content-center>
        <v-card style="margin-top: 100px">
          <v-toolbar color="#00558c" dark>
            <v-card-title class="headline" color="white"
              >Thank You</v-card-title
            >
          </v-toolbar>
          <v-layout justify-center align-content-center style="padding: 25px">
            <v-subheader class="commonFont" style="color: #00558c">
              Your request for contact has been submitted. An agent will be in
              contact with you soon.
              <br /><br />
            </v-subheader>
          </v-layout>
        </v-card>
      </v-layout>
    </div>
    <v-dialog v-model="waitDialog" width="300">
      <v-card color="white">
        <v-card-title
          class="headline"
          primary-title
          :style="{ color: mainColor }"
        >
          <v-layout justify-center align-content-center>Please Wait</v-layout>
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" width="500">
      <v-card color="white">
        <v-card-title
          class="headline"
          primary-title
          :style="{ color: mainColor }"
        >
          <v-layout justify-center align-content-center>We're Sorry</v-layout>
        </v-card-title>
        <span>
          Your request cannot be completed at this time. Please contact us at
          <a href="mailto:ESD_SofNM@globe.life" style="text-decoration: none"
            >ESD_SofNM@globe.life</a
          >
          to continue.
        </span>
        <br />
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
import { AWS_HTTP } from '../http-common.js'
import { log } from '../http-common.js'

import eventBus from '../event-bus'
export default {
  props: { mainColor: String, entity: Object },
  data: () => ({
    showAltDemographics: true,
    showSubmitted: false,
    errors: [],
    valid: true,
    name: '',
    nameRules: [
      (v) => !!v || 'Full name is required.',
      (v) => (v && v.length > 2) || 'Name must be more than 2 characters.',
    ],
    firstName: '',
    firstNameRules: [
      (v) => !!v || 'First name is required.',
      (v) => (v && v.length > 1) || 'First name must be at least 2 characters.',
    ],
    middleName: '',
    lastName: '',
    lastNameRules: [
      (v) => !!v || 'Last name is required.',
      (v) => (v && v.length > 1) || 'Last name must be at least 2 characters.',
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required.',
      (v) =>
        /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
          v.trim()
        ) || 'E-mail must be valid',
      //v => /.+@.+\.{1}.+/.test(v) || 'E-mail must be valid'
    ],

    homePhone: '',
    workPhone: '',
    phoneRules: [
      (v) => !!v || 'Primary phone number is required.',

      (v) =>
        /^[\d{1}]?[ ]?[.\-( ]?[ ]?\d{3}[ ]?[.\-) ]?[ ]?\d{3}[.\- ]?\d{4}[ ]*$/.test(
          v
        ) || 'Please enter a valid phone number with area code.',
    ],
    phoneRules2: [
      (v) =>
        !v ||
        /^[\d{1}]?[ ]?[.\-( ]?[ ]?\d{3}[ ]?[.\-) ]?[ ]?\d{3}[.\- ]?\d{4}[ ]*$/.test(
          v
        ) ||
        'Please enter a valid phone number with area code.',
    ],
    waitDialog: false,
    errorDialog: false,
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if (this.$refs.form.validate()) {
          this.waitDialog = true
          AWS_HTTP.get('email', {
            params: {
              FirstName: this.firstName,
              LastName: this.lastName,
              MiddleName: this.middleName,
              Email: this.email,
              Phone: this.$options.filters.phone(this.homePhone),
              WorkPhone: this.$options.filters.phone(this.workPhone),
            },
          })
            .then(() => {
              this.waitDialog = false

              this.showAltDemographics = false
              this.showSubmitted = true

              // console.log(response)
            })
            .catch((e) => {
              this.waitDialog = false
              this.errorDialog = true
              // console.log(e)
              log(e.toString(), true, 'alt-demographics.vue submit')
              this.errors.push(e)
            })
        }
      }
    },
    retry() {
      eventBus.$emit('showVerification')
    },
  },
}
</script>
<style scoped>
</style>